<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">Filtre et recherche – compétitions Poomsae</h3>
                        <button niveau="button"
                                class="btn btn-xs btn-default btn-flat margin pull-right"
                                style="margin-top: 0;margin-bottom: 0;"
                                @click="resetFilter()"
                        >
                            Réinitialiser les filtres
                        </button>
                    </div>
                    <div class="box-body">
                        <div class="row">
                            <div class="col-md-2 input-daterange" id="dataRange">
                                <div class="form-group">
                                    <label>Du:</label>
                                    <div class="input-group date">
                                        <div class="input-group-addon">
                                            <i class="fa fa-calendar"></i>
                                        </div>
                                        <masked-input type="text"
                                                      v-model="periodeDu"
                                                      name="periodeDu"
                                                      v-validate="'required|date_format:DD/MM/YYYY'"
                                                      :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                                      :guide="true"
                                                      :keepCharPositions="true"
                                                      :showMask="true"
                                                      class="form-control pull-right datepicker"
                                                      id="periodeDu">
                                        </masked-input>
                                    </div>
                                </div>
                                <div class="form-group ">
                                    <label>Au:</label>
                                    <div class="input-group date ">
                                        <div class="input-group-addon">
                                            <i class="fa fa-calendar"></i>
                                        </div>
                                        <masked-input type="text"
                                                      v-model="periodeAu"
                                                      name="periodeAu"
                                                      v-validate="'required|date_format:DD/MM/YYYY|after:periodeDu,true'"
                                                      :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                                      :guide="true"
                                                      :keepCharPositions="true"
                                                      :showMask="true"
                                                      class="form-control pull-right datepicker"
                                                      id="datepicker2">
                                        </masked-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label for="niveau">Niveau de la compétition</label>
                                    <select id="niveau" class="form-control" name="competition[niveau]" v-model="niveauSelectedForFilter">
                                        <option value="-1">Indéterminé</option>
                                        <option
                                                v-for="niveau in getNiveauxCompetitionPoomsae"
                                                :value="niveau.id"
                                        >{{niveau.niveau}}
                                        </option>
                                    </select>
                                </div>
<!-- 
                                <div class="form-group">
                                    <label for="jo">Jeux Olympiques</label>
                                    <select id="jo" class="form-control" name="competition[jo]" v-model="jo">
                                        <option value="-1">Indéterminé</option>
                                        <option value="1">Oui</option>
                                        <option value="0">Non</option>
                                    </select>
                                </div> -->
                            </div>

                            <!-- <div class="col-md-2">
                                <div class="form-group">
                                    <label for="labelise">Labelisé ABFT</label>
                                    <select id="labelise" class="form-control" name="competition[labelise]" v-model="labelise">
                                        <option value="-1">Indéterminé</option>
                                        <option value="1">Oui</option>
                                        <option value="0">Non</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="olympique">Categorie de poids olympique</label>
                                    <select id="olympique" class="form-control" name="competition[olympique]" v-model="olympique">
                                        <option value="-1">Indéterminé</option>
                                        <option value="1">Oui</option>
                                        <option value="0">Non</option>
                                    </select>
                                </div>
                            </div> -->



                        </div>
                    </div>
                    <div class="box-footer">
                        <input niveau="submit" @click.prevent="searchCompetitions()" value="Rechercher" class="btn btn-primary pull-right"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <b-col md="9" class="my-1">
                            <h3 class="box-title">Listing des compétitions Poomsae: {{pagination_meta.total}} résultat{{pagination_meta.total>1 ? 's':''}}</h3>
                        </b-col>
                        <b-col md="3" class="my-1">
                            <b-form-input v-model="filter" style="height: 28px;" placeholder="Rechercher..."></b-form-input>
                        </b-col>

                    </div>
                    <div class="box-body">
                        <b-table
                                id="tableListingAllCompetitions"
                                v-if="!loadingListingCompetition && listingCompetitions.length>0"
                                responsive bordered striped hover
                                :items="listingCompetitions"
                                :fields="columnsListingCompetition"
                                :filter="filter"
                                :per-page="pagination_meta.per_page"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :no-local-sorting="true"
                                :no-sort-reset="true"
                                :empty-text="'Aucun résultat'"
                                :empty-filtered-text="'Aucun résultat'"
                                foot-clone
                                show-empty
                        >
                            <template slot="actions" slot-scope="row">
                                <router-link
                                        class="btn btn-default padding2"
                                        :to="{ name: 'CompetitionPoomsae', params: { competition_id: row.item.id }}">
                                    <i class="glyphicon glyphicon-pencil"></i>
                                </router-link>
                            </template>
                            <!-- <template slot="labelise" slot-scope="data">
                                {{data.value ? "OUI":"NON"}}
                            </template> -->
                            <!-- <template slot="olympique" slot-scope="data">
                                {{data.value ? "OUI":"NON"}}
                            </template> -->
                            <template slot="competition" slot-scope="row">
                                <router-link
                                        :to="{ name: 'CompetitionPoomsae', params: { competition_id: row.item.id }}">
                                    {{row.item.competition }}
                                </router-link>
                            </template>
                            <template slot="niveau" slot-scope="data">
                                {{data.item.niveau}}
                            </template>
                            <template slot="nombre_inscrits" slot-scope="data">
                                {{data.item.nombre_inscrits}}{{data.item.nombre_inscrits>1 ? " compétiteurs" : " compétiteur"}}
                            </template>
                        </b-table>
                        <b-pagination size="md"
                                      @change="changePage"
                                      :total-rows="pagination_meta.total"
                                      v-model="pagination_meta.current_page"
                                      :per-page="pagination_meta.per_page">
                        </b-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import {mapGetters, mapActions} from 'vuex'
    import {ErrorBag} from 'vee-validate';
    import vSelect from '../../Communs/vSelect/index'
    import ListSelectClub from '../../Communs/listeSelectClub'

    require('bootstrap-datepicker/js/bootstrap-datepicker')
    require('bootstrap-datepicker/js/locales/bootstrap-datepicker.fr')

    var _ = require('underscore')
    var moment = require('moment')

    export default {
        props: {},
        data() {
            return {
                sortBy: null,
                sortDesc: false,
                filter: null,
                sortDirection: 'asc',
                listingCompetitions: [],
                loadingListingCompetition: true,
                isBusy: false,
                current_page: 1,
                periodeDu: null,
                periodeAu: null,
                niveau:-1,
                olympique:-1,
                labelise:-1,
                jo:-1,
                niveauSelectedForFilter: -1,
                reset: false,
                pagination_meta: {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    path: "",
                    per_page: 20,
                    to: 1,
                    total: 1
                },
                columnsListingCompetition: [
                    {
                        label: 'Date',
                        key: 'date_debut',
                        sortable: true,
                    },
                    {
                        label: 'Competition',
                        key: 'competition',
                        sortable: true,
                    },
                    {
                        label: 'Niveau',
                        key: 'niveau',
                        sortable: true,
                    },
                    // {
                    //     label: 'Lablisé ABFT',
                    //     key: 'labelise',
                    //     sortable: true,
                    // },
                    // {
                    //     label: 'Categ. olympique',
                    //     key: 'olympique',
                    //     sortable: true,
                    // },
                    {
                        label: 'Nombre d\'inscrits',
                        key: 'nombre_inscrits',
                        sortable: true,
                    },
                    {
                        label: 'Actions',
                        key: 'actions',
                    },
                ]
            }
        },
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
                getNiveauxCompetitionPoomsae: 'getNiveauxCompetitionPoomsae',
            }),
        },
        mounted: function () {
            var these = this
            this.$nextTick(function () {
                this.periodeAu=moment().format('DD/MM/YYYY')
                this.periodeDu="01/01/2000"
                this.getTableListingCompetition();


                // $('.input-daterange').datepicker({
                //     autoclose: true,
                //     language: 'fr',
                // }).on("changeDate", function (e) {
                //     these.periodeDu = $('#datepicker1').val()
                //     these.periodeAu = $('#datepicker2').val()
                // });
            })
        },
        created() {
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.periodeAu=moment().format('DD/MM/YYYY')
                vm.periodeDu=moment().format('DD/MM/YYYY')
            })
        },
        watch: {
            'sortBy': function (val) {
                this.getTableListingCompetition()
            },
            'sortDesc': function (val) {
                this.getTableListingCompetition()
            },
            'periodeDu': function (val) {
                this.constructSearchRequest()
            },
            'periodeAu': function (val) {
                this.constructSearchRequest()
            },
            'niveauSelectedForFilter': function (val) {
                this.constructSearchRequest()
            },
            // 'jo': function (val) {
            //     this.constructSearchRequest()
            // },
            // 'olympique': function (val) {
            //     this.constructSearchRequest()
            // },
            // 'labelise': function (val) {
            //     this.constructSearchRequest()
            // },
        },
        components: {
            vSelect,
            ListSelectClub,
        },
        methods: {
            ...mapActions({
                setStatusCompetitionPoomsae: 'setStatusCompetitionPoomsae',
            }),
            searchCompetitions: function () {
                this.sortDesc = null;
                this.sortBy = null;
                this.getTableListingCompetition();
            },
            resetFilter: function () {
                this.niveauSelectedForFilter = null;
                this.periodeDu = null;
                this.periodeAu = null;
                this.reset = !this.reset;
            },
            constructSearchRequest: function () {
                var objectTemp = {}
                if (this.periodeDu != '' && this.periodeDu != null)
                    objectTemp.periodeDu = this.periodeDu
                if (this.periodeAu != '' && this.periodeAu != null)
                    objectTemp.periodeAu = this.periodeAu
                if (this.niveauSelectedForFilter != '' && this.niveauSelectedForFilter > 0 && this.niveauSelectedForFilter != null)
                    objectTemp.niveauSelectedForFilter = this.niveauSelectedForFilter



                if (this.pagination_meta.per_page != 0 && this.pagination_meta.per_page != null)
                    objectTemp.perPage = this.pagination_meta.per_page
                if (this.sortBy != null) {
                    let sortDesc = this.sortDesc != null ? this.sortDesc == true ? "asc" : "desc" : "desc"
                    objectTemp.sort = this.sortBy + "|" + sortDesc
                }
                if (this.pagination_meta.current_page != 0 && this.pagination_meta.current_page != null)
                    objectTemp.currentPage = this.pagination_meta.current_page

                return (objectTemp);
            },
            changePage: function (e) {
                this.pagination_meta.current_page = e
                this.getTableListingCompetition();
            },
            updateNiveauSelected: function (value) {
                this.niveauSelectedForFilter = value.id;
            },
            currentYear: function () {
                return moment().year();
            },
            getTableListingCompetition: function () {
                this.loadingListingCompetition = true;
                this.isBusy = true
                let self = this
                // debugger;
                this.$http.post(self.getRoute('Secretariat.competitionPoomsae.getAll'), this.constructSearchRequest())
                    .then((response) => {
                        self.listingCompetitions = response.body.data
                        self.pagination_meta = response.body.meta
                        self.loadingListingCompetition = false;
                        // debugger;
                        // self.$root.$emit('bv::refresh::table', 'tableListingAllCompetitions');
                        // self.$refs.tableListingAllCompetitions.refresh();
                        // self.isBusy = false
                        // return response.body.data;
                    }, (response) => {
                        self.listingCompetitions = []
                        // self.$root.$emit('bv::refresh::table', 'tableListingAllCompetitions');
                        // debugger;
                        // self.$refs.tableListingAllCompetitions.refresh();

                        // self.isBusy = false
                        // return []
                    });
                // return null
            },
            isTableListingCompetitionLoading: function (force = false) {
                if (force)
                    return true
                return this.loadingListingCompetition;
            },
            console: function (event) {
                console.log(event);
            },
            formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
                if (value == null) return ''
                return moment(value, fmtIn).format(fmtOut)
            },
        },
        filters: {
            idFormat: function (value) {
                return new Intl.NumberFormat("de-DE").format(value)
            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/components/Secretariat/CompetitionPoomsae/ListingCompetitionPoomsae.vue